module.exports = __webpack_public_path__ + "img/GL.1c40c653.svg";